module.exports = __webpack_public_path__ + "img/main_icon_badge_3k.c78291d.png";